/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FormOpportunity {
  BeforeBooking = 'BeforeBooking',
  AfterBooking = 'AfterBooking',
  BeforeCase = 'BeforeCase'
}
